import { makeStyles } from '@material-ui/core';
import { calculateWidth, rem, vh, vw } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

export const styles = makeStyles(theme => ({
  dialogPaper: {
    minHeight: '100%',
    minWidth: '100%',
    borderRadius: 'unset',
    background: themeColor.modalBackground,
    overflowY: 'hidden',
  },
  mainContainer: {
    flexGrow: 1,
    border: `1px solid ${themeColor.secondaryLight}`,
  },
  actionTitle: {
    fontSize: rem(2),
    fontWeight: 500,
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    marginTop: vh(6.5),
    color: themeColor.modalTitle,
  },
  actionSubTitle: {
    fontSize: rem(1.125),
    '@media (width: 1024px) and (height: 576px)': {
      fontSize: rem(0.9),
    },
    fontWeight: 500,
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    marginTop: vh(1.5),
    color: themeColor.subheaderLight,
    marginBottom: vh(8),
  },
  title: {
    display: 'flex',
    padding: '2.08vh 1.464vw',
    backgroundColor: 'white',
    borderBottom: `1px solid ${themeColor.secondaryLight}`,
    alignItems: 'center',
    justifyContent: 'space-between',

    '& svg': {
      height: '3.125vh',
      width: '3.125vh',
    },
  },
  titleContent: {
    fontSize: rem(1.285),
    lineHeight: rem(1.428),
    fontWeight: 500,
    color: themeColor.modalTitle,
  },
  textContainer: {
    width: 'fit-content',
    display: 'flex',
    alignItems: 'flex-start',
    margin: 'auto',
  },
  inputTextArea: {
    marginTop: vh(2.5),
    fontSize: rem(1.125),
    color: themeColor.defaultTextColor,
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    outline: 'none',
    height: '22%',
    width: vw(33),
  },
  bottomContainer: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    flexGrow: 10,
    paddingBottom: '22vw',
    backgroundColor: themeColor.modalBackground,
    '@media (width: 1366px) and (height: 768px)': {
      paddingBottom: '21vw',
    },
  },
  buttonContainer: {
    marginRight: '2.0497803807vw',
    height: '10vh',
    '@media (aspect-ratio: 4/3)': {
      height: '18vh',
    },
    '@media (aspect-ratio: 16/9)': {
      height: '9vh',
    },
  },
  mainContent: {
    flexGrow: 1,
    padding: '0 1.464vw 2.604vh 1.464vw',
    alignItems: 'center',
  },
  idTextInput: {
    width: vw(41),
    '@media (aspect-ratio: 16/9)': {
      width: vw(31),
    },
    '@media(width: 1366px) and (height:768px)': {
      width: vw(31),
    },
    marginBottom: vh(9),
  },
  nameTextInput: {
    width: vw(41),
    '@media (aspect-ratio: 16/9)': {
      width: vw(31),
    },
    '@media(width: 1366px) and (height:768px)': {
      width: vw(31),
    },
    marginBottom: vh(7),
    '@media (width: 1024px) and (height: 576px)': {
      marginBottom: vh(5),
    },
  },
  cancelButton: {
    fontSize: vh(2.08),
    border: `solid 1px ${themeColor.secondaryLight}`,
    color: themeColor.almostblack,
    width: vw(20.5),
    '@media (aspect-ratio: 16/9)': {
      width: vw(15.5),
    },
    '@media(width: 1366px) and (height:768px)': {
      width: vw(15.5),
    },
    marginRight: vw(1),
  },
  approveButton: {
    marginLeft: calculateWidth(10).stringValue,
    fontSize: vh(2.08),
    width: vw(20.5),
    '@media (aspect-ratio: 16/9)': {
      width: vw(15.5),
    },
    '@media(width: 1366px) and (height:768px)': {
      width: vw(15.5),
    },
    border: `1px solid ${themeColor.secondaryLight}`,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
    '&:disabled': {
      color: themeColor.rollingStone,
      background: themeColor.progressBar,
      opacity: '1',
      '& span': {
        opacity: 1,
      },
    },
  },
  centerButtons: {
    justifyContent: 'center',
  },
}));
